import { mapState } from 'vuex';

export default {
  data() {
    return {
      isModified: false,
      value: JSON.parse(JSON.stringify(this.initialValue)),
      hint: null
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    // Any type is allowed (we don't know until the document is loaded)
    // Optional because insert forms have no values when initialized
    initialValue: {},
    resolved: {},
    // This object should contain the condition sources with values to proper validate this field
    // the sources and values should be provided in this way: { "fieldName": "value" } for easy access
    conditionSources: {
      type: {},
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(value) {
      this.$emit('change', value);
    }
  },
  computed: {
    ...mapState({
      datatypes: 'models',
      language: 'selectedLanguage'
    }),
    validationRules: {
      get() {
        const schemaValidations = this.config.validations;
        if (!schemaValidations) {
          return [];
        }
        return schemaValidations
          .map((schemaValidation) => {
            switch (schemaValidation.type) {
              case 'required':
                return (value) => this.validRequired(value);
              case 'regex':
                return (value) =>
                  new RegExp(schemaValidation.match).test(value) ||
                  this.$t('validation.mustMatch', { pattern: schemaValidation.readable });
              case 'unset':
              // return () =>
              //   !this.modifiedRecord[schemaValidation.source] ||
              //   !this.modifiedRecord[schemaValidation.source].length ||
              //   this.$t('validation.unset', {
              //     label: this.schema.filter(e => e.name === schemaValidation.source).pop.label
              //   });
              case 'mime-type':
              /** this needs an async validation.
               * if the field refers to an external file (eg. externalPoster), a request for the http headers has to be made,
               * to retrieve the mime/content-type.
               *
               * Unfortunately, vuetify is not capable of handling async validation out of the box and most likely never won't:
               * https://github.com/vuetifyjs/vuetify/issues/4231#issuecomment-725595876
               *
               * This has to be resolved with an additional library, like vee-validate
               */
              default:
                console.log(`${schemaValidation.type} validation not yet implemented`);
                break;
            }
          })
          .filter((validation) => !!validation);
      }
    }
  },
  methods: {
    validRequired(value) {
      if (this.config.conditions) {
        const conditionSourceHasData = this.config.conditions.some(
          (condition) => condition.exists === false && !!this.conditionSources[condition.source]
        );
        if (!!value && conditionSourceHasData) {
          return this.$t('validation.conditionalSourcesMustBeEmpty', {
            fields: [this.name, ...this.config.conditions.map((condition) => condition.source)].join(', ')
          });
        }
      }
      return !!value || this.$t('validation.required');
    }
  }
};
